import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme({
  typography: {
    fontFamily: '"Baloo 2", cursive',
  },
  h1: { fontSize: '2rem' },
  h2: { fontSize: '1.625rem' },
  h3: { fontSize: '1.5rem' },
  h4: { fontSize: '1.25rem' },
  h5: { fontSize: '1.125rem' },
  h6: { fontSize: '1rem' },

  body1: {
    fontFamily: '"Albert Sans", sans-serif',
    fontWeight: 400,
    fontSize: '1rem',
    color: '#000000',
  },

  body2: {
    fontFamily: '"Albert Sans", sans-serif',
    fontWeight: 400,
    fontSize: '0.875rem',
    color: '#000000',
  },
  
  palette: {
    primary: {
      main: '#0E4264',
    },
    secondary: {
      main: '#19857b',
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    action: {
      disabledOpacity: 1 //1 to remove opactiy
    }
  },
  components: {
      MuiInputBase: {
        styleOverrides: {
          input: {
            '&.Mui-disabled': {
              WebkitTextFillColor: 'black',
            },
          },
        },
      },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&.Mui-disabled': {
            WebkitTextFillColor: 'black',
          },
        },
      },
    }/* , 
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            "&.Mui-disabled:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "inherit",
            },
          },
        },
      }, */
    }
  });

export default theme;